import Layout from '@/layout'

const route = {
  path: '/enterprisewechatControl',
  component: Layout,
  redirect: '/enterprisewechatControl/index',
  alwaysShow: true, // will always show the root menu
  name: 'enterprisewechatControl',
  meta: {
    title: '企微控制',
    icon: 'diy-QiWzKsVi',
    roles: [
      'wwPhone'
    ]
  },
  children: [
    {
      path: '/weworkPhoneList/index',
      component: () => import('@/views/weworkPhoneList/index.vue'),
      name: 'WeworkPhoneList',
      meta: {
        title: '手机管理',
        roles: [
          'wwPhone.manage'
        ]
      }
    },
    {
      path: '/weworkPhoneListNew/index',
      component: () => import('@/views/weworkPhoneListNew/index.vue'),
      name: 'WeworkPhoneListNew',
      meta: {
        title: '手机管理（新）',
        roles: [
          'wwPhone.manage.new'
        ]
      }
    },
    {
      path: '/autoScriptManagement/index',
      component: () => import('@/views/autoScriptManagement/index.vue'),
      name: 'AutoScriptManagement',
      meta: {
        title: '自动化脚本管理',
        roles: [
          'wwPhone.autoScript.manage'
        ]
      }
    },
    {
      path: '/otaphone/index',
      component: () => import('@/views/otaphone/index.vue'),
      name: 'Otaphone',
      meta: {
        title: 'Ota管理',
        // icon: 'component',
        roles: [
          'wwPhone.ota'
        ]
      }
    },
    {
      path: '/windowsClientManagement/index',
      component: () => import('@/views/windowsClientManagement/index.vue'),
      name: 'Otaphone',
      meta: {
        title: 'Win客户端管理',
        // icon: 'component',
        roles: [
          'windowsClient'
        ]
      }
    },
    {
      path: '/employeeBusinessCardGroup/index',
      component: () => import('@/views/employeeBusinessCardGroup/index.vue'),
      name: 'EmployeeBusinessCardGroup',
      meta: {
        title: '员工名片群管理',
        // icon: 'component',
        roles: [
          'spWorkWechat.wwScript.businessGroupChat'
        ]
      }
    },
    {
      path: '/businessCardSendRecord/index',
      component: () => import('@/views/businessCardSendRecord/index.vue'),
      name: 'BusinessCardSendRecord',
      meta: {
        title: '名片发送记录',
        roles: [
          'spWorkWechat.wwScript.businessCardRecord'
        ]
      }
    }
  ]
}

export default route
